import { type CoreUIAppModule, CoreUIProvider, type PrimaryThemeName } from '@eleo-rh/core-ui'
import { ModalProvider } from '@eleo-rh/core-ui/contexts'
import { App } from 'antd'
import { useI18n } from 'context/I18nProvider'
import { useQuery } from 'context/QueryProvider'
import ToastProvider from 'context/ToastProvider'
import { type PropsWithChildren, useEffect, useState } from 'react'
import SettingsSingleton from 'services/SettingsSingleton'

const langMap = {
  de: 'de',
  en: 'en-gb',
  fr: 'fr',
} as const

export default function CoreUIProviderAdapter({ children }: PropsWithChildren) {
  const { i18n, locale } = useI18n()
  const { client } = useQuery()
  const [mainColor, setMainColor] = useState<PrimaryThemeName | null>()
  const [module, setModule] = useState<CoreUIAppModule>('training')

  useEffect(() => {
    void SettingsSingleton.getInstance()
      .getSettings(client)
      .then(settings => {
        setMainColor(settings?.mainColor ?? null)
        setModule(settings?.safetyStandalone ? 'safety' : 'eleo')
      })
  }, [client])

  return (
    <CoreUIProvider
      lang={langMap[locale as keyof typeof langMap] ?? 'fr'}
      module={module}
      primaryTheme={mainColor}
      onPrimaryThemeChange={setMainColor}
      form={{ validateMessages: { required: i18n('required_field') } }}
      theme={{
        components: {
          Listy: {
            itemPaddingBlock: 24,
            controlItemBgHover: 'var(--color-slate-50)',
          },
        },
      }}
    >
      <App>
        <ToastProvider>
          <ModalProvider>{children}</ModalProvider>
        </ToastProvider>
      </App>
    </CoreUIProvider>
  )
}
